import {
  AfterViewInit,
  ContentChildren,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  QueryList,
} from '@angular/core';

@Directive({
  selector: '[appDeferLoad]',
})
export class DeferLoadDirective implements AfterViewInit, OnDestroy {
  @Input() public self: boolean;
  @Input() public root: Element = null;
  @Output() public appDeferLoad: EventEmitter<any> = new EventEmitter();
  @ContentChildren('element') public elements: QueryList<ElementRef>;
  private intersectionObserver: IntersectionObserver;
  private lastElement: Element;

  constructor(private elRef: ElementRef) {}

  public ngAfterViewInit(): void {
    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        this.checkForIntersection(entries);
      },
      {
        root: this.root,
      }
    );
    if (this.self) {
      this.resubElement(this.elRef);
    } else {
      this.resubElement(this.elements.last);
      this.elements.changes.subscribe((res: QueryList<ElementRef>) => {
        this.resubElement(res.last);
      });
    }
  }

  private resubElement(element: ElementRef) {
    if (!element) {
      return;
    }

    if (this.lastElement) {
      this.intersectionObserver.unobserve(this.lastElement);
    }

    this.lastElement = element.nativeElement;
    this.intersectionObserver.observe(this.lastElement);
  }

  private checkForIntersection(entries: Array<IntersectionObserverEntry>) {
    entries.forEach((entry: IntersectionObserverEntry) => {
      if (this.checkIfIntersecting(entry)) {
        this.appDeferLoad.emit();
        if (this.self) {
          this.destroy();
        }
      }
    });
  }

  private checkIfIntersecting(entry: IntersectionObserverEntry) {
    return entry.isIntersecting && entry.target === this.lastElement;
  }

  private destroy() {
    if (this.intersectionObserver) {
      if (this.lastElement) {
        this.intersectionObserver.unobserve(this.lastElement);
      }
      this.intersectionObserver.disconnect();
    }
  }

  public ngOnDestroy(): void {
    this.destroy();
  }
}
